import { render, staticRenderFns } from "./IdentityFilters.vue?vue&type=template&id=6a056fc0&scoped=true"
import script from "./IdentityFilters.vue?vue&type=script&lang=js"
export * from "./IdentityFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a056fc0",
  null
  
)

export default component.exports